

export interface RecruiterCreateRequest {
  userId: string;
  companyId: string;
  designation: string;
  isCompanyAdminUser: boolean;
  recruiterFirstName: string;
  recruiterLastName: string;
  recruiterEmail: string;
}


export const initialRecruiterResponse: RecruiterResponse = {
  id: "",
  userId: "",
  companyId: "",
  designation: "",
  isCompanyAdminUser: false,
  recruiterFirstName: "",
  recruiterLastName: "",
  recruiterEmail: "",
  recruiterStatus: false,

  recruiterCreatedAt: "",
  recruiterUpdatedAt: "",
};


export interface RecruiterResponse {
  id: string;
  userId: string;
  companyId: string;
  designation: string;
  isCompanyAdminUser: boolean;
  recruiterFirstName: string;
  recruiterLastName: string;
  recruiterEmail: string;
  recruiterStatus: boolean;

  recruiterCreatedAt: string;
  recruiterUpdatedAt: string;
}


export interface RecruiterUpdateRequest {
  id: string;
  designation?: string;
  recruiterFirstName?: string;
  recruiterLastName?: string;
  recruiterEmail?: string;
  recruiterStatus?: boolean;
}

/**
 * Aggregate counts for the company recruiter listing.
 */
export interface RecruiterStats {
  total: number;
  admins: number;
  active: number;
  disabled: number;
}